// Tint options for the share card. `stops: null` is the neutral scheme (pure
// surface tokens); the others are content colors the user picks to tint the
// card wash, the logo and the QR modules — so they are data here, not UI chrome.

export const SHARE_TINTS = [
    { id: 'neutral', stops: null },
    { id: 'sunset', stops: ['#FF7A59', '#FF3D81'] },
    { id: 'ocean', stops: ['#2E6BFF', '#5CE1E6'] },
    { id: 'forest', stops: ['#0F9D58', '#A8E063'] },
    { id: 'violet', stops: ['#7F5AF0', '#E45BFF'] },
    { id: 'ember', stops: ['#F5A524', '#F5576C'] },
];

// Gradient direction, and how much of it bleeds into the card fill.
export const TINT_ANGLE = 160;
export const TINT_WASH = 0.22;

export function findTint(id) {
    return SHARE_TINTS.find(t => t.id === id) || SHARE_TINTS[0];
}
